import {
  Component,
  AfterViewInit,
  OnInit,
  HostListener,
  HostBinding,
  OnDestroy, Renderer2, PLATFORM_ID, Inject,
} from '@angular/core';
import { UpdateService } from './service/utility/sw/update.service';
import { IconService } from './service/utility/icon/icon.service';
import { ActivatedRoute, NavigationStart, Router, NavigationEnd } from '@angular/router';
import { Subscription, Observable, interval } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Store, select } from '@ngrx/store';
import { IAppState } from './store/state/app.state';
import { GetMenu } from './store/actions/menu.actions';
import { GetNext } from './store/actions/next.actions';

import { OverlayContainer } from '@angular/cdk/overlay';
import { GetIdentify, AddToken } from './store/actions/identify.actions';
import { selectIdentify } from './store/selectors/identify.selectors';
import { GetLanguages } from './store/actions/languages.actiosn';
import {
  PageAddSession,
  PageGetIp,
  PageAddFirstStreaming,
  PageAddLogo,
  PageAddImagesHome,
  PageAddImagesCart,
  PageAddTrackGA,
  PageAddVideoEnabled,
  PageAddShowTicketList,
  PageAddFunctionCompleteBet,
  PageAddPlayVideo,
  PageAddDisableAudio,
  PageSetTypeMenu,
  PageSetSystemBetMenu,
  PageAddFunctionButtonBet,
  PageSetMenuTabIndex,
  PageSetHidefullstats, PageSetTerminalTag, PageAddCID, PageConfirmBetState, PageCoverVideo, PageShowMenu,
} from './store/actions/page.actions';
import { MonitoringService } from './service/utility/monitoring/monitoring.service';
import { selectIp } from './store/selectors/page.selectors';
import { VideoService } from './service/video/video.service';
import { IIdentify } from './models/identify.interface';
import {filter, startWith, take} from 'rxjs/operators';
import { GoogleAnalyticsService } from './service/analytics/google-analytics.service';
import { GetResultRace } from './store/actions/raceresult.actions';
import { IMessage } from './models/message.interface';
import { selectMessage } from './store/selectors/message.selectors';
import {environment} from '../environments/environment';
import {NotTranslatedServiceService} from './service/translate/not-translated-service.service';
import {ResponsiveService} from './service/utility/responsive/responsive.service';
import {subscriptionLogsToBeFn} from 'rxjs/internal/testing/TestScheduler';
import {IMenu} from './models/menu.interface';
import {selectMenu} from './store/selectors/menu.selectors';
import {isPlatformBrowser} from '@angular/common';
import {versionInfo} from './version-info';
import {ICarousel} from './models/carousel.interface';
import {DeviceDetectorService} from 'ngx-device-detector';
import {GetChannels} from './store/actions/channels.actions';
import {PostmessageService} from './service/utility/sendmessage/postmessage.service';
import {microgameDark, microgameLight} from '../environments/cIDpartner';

/**
 * Componente padre applicazione
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

  logoStaging =  '            .\'\'\n' +
      '  ._.-.___.\' (`\\\n' +
      ' //(        ( `\'\n' +
      '\'/ )\\ ).__. ) \n' +
      '\' <\' `\\ ._/\'\\\n' +
      '   `   \\     \\\n' +
      versionInfo.raw;

  logo =  '            .\'\'\n' +
      '  ._.-.___.\' (`\\\n' +
      ' //(        ( `\'\n' +
      '\'/ )\\ ).__. ) \n' +
      '\' <\' `\\ ._/\'\\\n' +
      '   `   \\     \\\n' +
      versionInfo.tag;

  /**
   * Altezza minima da mandare alla pagina padre dell'iframe
   */
  private _heightFrame = 0;

  /**
   * Subscriptioncountdown
   */

  private _subscriptionTimerHeight: Subscription;

  private _subscriptionIdentifyObs: Subscription;

  private _subscriptionmenuObs: Subscription;

  private _timerHeight: Observable<number>;

  private _identifyObs$: Observable<IIdentify>;

  public message$: Observable<IMessage>;

  public menu$: Observable<IMenu>;

  public showMessage = false;

  @HostBinding('class') componentCssClass: string;

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    if (event.data) {
      // console.log(event.data);
      if (event.data.urlimagelogo && event.data.urlimagelogo !== '') {
        this._store.dispatch(new PageAddLogo(event.data.urlimagelogo));
      }
      if (event.data.imageshome && event.data.imageshome.length > 0) {
        if (environment.betflafCID.includes(event.data.cID) &&
            (event.data.terminalTag && (event.data.terminalTag === 140 || event.data.terminalTag === 150 || event.data.terminalTag === 141 || event.data.terminalTag === 151 ))) {
            // niente
        } else {
          this._store.dispatch(new PageAddImagesHome(event.data.imageshome));
        }
      }
      if (event.data.imagescart && event.data.imagescart.length > 0) {
        this._store.dispatch(new PageAddImagesCart(event.data.imagescart));
      }
      if (event.data.cID && event.data.cID !== '' && event.data.sID && event.data.sID !== '') {
        if (event.data.sID === 'LOGOUT') {
          this._store.dispatch(new PageAddSession(''));
        } else {
          this._store.dispatch(new PageAddSession(event.data.sID));
        }
      }
      if (event.data.cID && event.data.cID !== '') {
        if (event.data.videoenabled !== undefined && event.data.videoenabled !== '') {
          this._store.dispatch(new PageAddVideoEnabled(JSON.parse(event.data.videoenabled)));
        }
        if (event.data.playvideo !== undefined && event.data.playvideo !== '') {
          this._store.dispatch(new PageAddPlayVideo(JSON.parse(event.data.playvideo)));
        }
        if (event.data.disableaudio !== undefined && event.data.disableaudio !== '') {
          this._store.dispatch(new PageAddDisableAudio(JSON.parse(event.data.disableaudio)));
        }
        if (event.data.type) {
          this._store.dispatch(new PageSetTypeMenu(event.data.type.replace(',', '|')));
        }
        if (event.data.bet) {
          let bet = event.data.bet;
          if (event.data.bet === 'TOT') {
            bet = 'TOT|TRIS';
          }
          this._store.dispatch(new PageSetSystemBetMenu(bet));
        }
      }
      // console.log(event.data.customCss);
      if (environment.staging && event.data.customCss && event.data.customCss !== '') {
        this.appInsightsService.createLink(
            event.data.customCss
        );
      }
      if (event.data.language && event.data.language !== '') {
        this.translateService.use(event.data.language);
        if (event.data.language === 'it-IT') {
          this._store.dispatch(new PageCoverVideo('assets/img/screen-video-horse-it.png'));
        }
      }
      if (event.data.tabMenu && event.data.tabMenu.length > 0) {
        if (this.responsiveService.fullSize.matches) {
          if (event.data.tabMenu.filter((x) => x.device === 'desktop').length > 0) {
            if (event.data.tabMenu.filter((x) => x.device === 'desktop')[0].index === 'nation') {
              this._store.dispatch(new PageSetMenuTabIndex(0));
            } else {
              this._store.dispatch(new PageSetMenuTabIndex(1));
            }
          }
        } else {
          if (event.data.tabMenu.filter((x) => x.device === 'mobile').length > 0) {
            if (event.data.tabMenu.filter((x) => x.device === 'mobile')[0].index === 'nation') {
              this._store.dispatch(new PageSetMenuTabIndex(0));
            } else {
              this._store.dispatch(new PageSetMenuTabIndex(1));
            }
          }
        }
      }

      if (event.data.meeting) {
        this._subscriptionmenuObs = this.menu$.pipe(
            filter((x) => !!x),
            take(1)
        ).subscribe((x) => {
          if (x && event.data.meeting !== '') {
            // const meetingMessageArray = event.data.meeting.split('-');
            const meet = x.country.filter((y) => y.code === event.data.meeting.substring(0, 3))[0];
            const id = meet.course.filter((me) => me.name.toLowerCase().trim().replace(/[^\w\s]/gi, '') === event.data.meeting.substring(3).replace(/[^\w\s]/gi, '').toLowerCase())[0].race.filter((r) => r.ss !== 'RU');
            if (id.length > 0) {
              this.router.navigate(['/pages/race', id[0].id], { queryParamsHandling: 'preserve' });
            }
          }
        });
      }

      if (event.data.hidefullstats && (event.data.hidefullstats === true || event.data.hidefullstats === 'true')) {
        this._store.dispatch(new PageSetHidefullstats(true));
      }

      if (event.data.terminalTag && event.data.terminalTag !== '') {
        this._store.dispatch(new PageSetTerminalTag(Number(event.data.terminalTag)));
      }

      if ((event.data.betConfirm && (event.data.betConfirm === true || event.data.betConfirm === 'true')) || (environment.staging && event.data.cID && environment.betflafCID.includes(event.data.cID)) ) {
        this._store.dispatch(new PageConfirmBetState(true));
      }

      if (event.data.coverVideo && event.data.coverVideo !== '' && event.data.coverVideo !== undefined) {
        this._store.dispatch(new PageCoverVideo(event.data.coverVideo));
      }

      if (event.data.racesMenuMobile !== '' && event.data.racesMenuMobile !== undefined) {
        this._store.dispatch(new PageShowMenu(event.data.racesMenuMobile));
      }

      // if (event.data.scroll) {
      //   const mstcart = document.getElementsByClassName('mst-cart')[0];
      //   const cart = document.getElementsByClassName('cart-stic')[0];
      //   if (cart !== undefined) {
      //     const initCart = document.getElementsByClassName('init-pos-cart')[0];
      //     // console.log(window.getComputedStyle(cart));
      //     // console.log(cart.getBoundingClientRect().top);
      //     // console.log(event.data.scroll.iframeTop + cart.getBoundingClientRect().top);
      //     const top = event.data.scroll.y - event.data.scroll.iframeTop;
      //     const cartPositionInit = event.data.scroll.iframeTop + initCart.getBoundingClientRect().top;
      //     if (event.data.scroll.y >= cartPositionInit) {
      //       cart.setAttribute('style', 'position:absolute; top:' + top + 'px; z-index: 9999; background: #ffffff; width: 100%; max-height: 90vh');
      //     } else {
      //       cart.removeAttribute('style');
      //     }
      //   } else {
      //     mstcart.removeAttribute('style'); // TODO Si può fare meglio che aspettare evento scroll
      //   }
      // }
    }
  }

  /**
   * Costruttore Injection
   * @param iconService servizio per utilizzare icone
   * @param route leggere parametri in query string
   * @param updateService servizio update sw
   * @param appInsightsService servizio per monitoraggio app
   * @param translateService servizio cambiare lingua
   * @param overlayContainer servizio cambio tema
   * @param videoService servizio url video
   * @param _store store ngr
   */
  constructor(
    private iconService: IconService,
    private router: Router,
    private route: ActivatedRoute,
    private updateService: UpdateService,
    private appInsightsService: MonitoringService,
    private translateService: TranslateService,
    public overlayContainer: OverlayContainer,
    private videoService: VideoService,
    private _store: Store<IAppState>,
    private postmessage: PostmessageService,
    public responsiveService: ResponsiveService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private nts: NotTranslatedServiceService,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object,
    private deviceService: DeviceDetectorService,
  ) {
    this.updateService.checkForUpdates();

    this.translateService.setDefaultLang('en-GB');

    this._identifyObs$ = this._store.pipe(select(selectIdentify));

    this._timerHeight = interval(2000).pipe(startWith(0));

    this.message$ = this._store.pipe(select(selectMessage));

    this.menu$ = this._store.pipe(select(selectMenu));

    /**
     * CREAZIONE LOGO VERSIONE
     * **/
    if (environment.staging) {
      console.log(this.logoStaging);
    } else {
      console.log(this.logo);
    }
  }

  /**
   * On Init del componente
   * Leggo parametri in query string e setto sessione e device.
   * Chiamo getconfig e chiamo ogni 10 secondi azione per menu e per next.
   */
  ngOnInit() {
    // this.googleAnalyticsService.subscribe();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (!!event.url && event.url.match(/^\/#/)) {
          this.router.navigate([event.url.replace('/#', '')]);
        }
      }
    });

    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams.sID && queryParams.sID !== 'LOGOUT') {
        if (queryParams.sID.search(',') !== -1) {
            this.nts.notTranslated(queryParams.sID);
        }
        if (environment.staging && environment.betflafCID.includes(queryParams.cID)) {
          console.log(queryParams.sID);
        }
        this._store.dispatch(new PageAddSession(queryParams.sID));

        if (queryParams.vEN) {
          this._store.dispatch(new PageAddVideoEnabled(JSON.parse(queryParams.vEN)));
        }
        // this.appInsightsService.setAuthenticatedUserId(queryParams.sID);
      } else {
        this._store.dispatch(new PageAddSession(''));
      }
      if (queryParams.cID) {
        this.appInsightsService.cID = queryParams.cID;

        // AGGIUNGO IL BANNER DI BETFALG PER APPLICAZIONE
        if (environment.betflafCID.includes(queryParams.cID)) {
          const deviceInfo = this.deviceService.getDeviceInfo();
          if (deviceInfo.os.toUpperCase() === 'IOS' || deviceInfo.os.toUpperCase() === 'ANDROID') {
            // Banner betflag
            const bannerBetflag = [{
              url: 'data:image/jpeg;base64,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',
              link: ''
            }];
            this._store.dispatch(new PageAddImagesHome(bannerBetflag));
          }
        }

        // Vecchio metodo con CID come nome css
        // let theme = 'mst';
        // if (environment.cID[queryParams.cID.toUpperCase()]) {
        //   theme = environment.cID[queryParams.cID.toUpperCase()].theme;
        // }
        // // this.componentCssClass = `theme-${queryParams.cID.toUpperCase()}`;
        // this.componentCssClass = `theme-${theme}`;
        //
        // this.overlayContainer
        //   .getContainerElement()
        //   .classList.add(`theme-${theme}`);
        //
        // if (!queryParams.cCSS || queryParams.cCSS !== '1' || !environment.staging) {
        //   this.appInsightsService.createLink(
        //     `/assets/css/style-${queryParams.cID.toUpperCase()}.css`
        //   );
        // }

        let theme = 'theme-mst';
        let css = '/assets/css/ui-style.css';
        if (environment.cID[queryParams['cID'].toUpperCase()]) {
          theme = 'theme-' + environment.cID[queryParams['cID'].toUpperCase()].theme;
          if (environment.cID[queryParams['cID'].toUpperCase()].customCss) {
            css = '/assets/css/' + environment.cID[queryParams['cID'].toUpperCase()].link + '.css';
          }
        }
        // Aggiungo il css di default oppure se è custom
        if (!queryParams['cCSS'] || queryParams['cCSS'] !== '1' || !environment.staging) {
          this.appInsightsService.createLink(css);
        }

        // Aggiungo il css creato dal sass
        if (environment.cID[queryParams['cID'].toUpperCase()] && environment.cID[queryParams['cID'].toUpperCase()].sass && !environment.staging) {
          const sass = '/assets/css/sass-' + environment.cID[queryParams['cID'].toUpperCase()].sass + '.css';
          this.appInsightsService.createLink(sass);
        }

        this.componentCssClass = theme;
        this.overlayContainer.getContainerElement().classList.add(theme);

        this._store.dispatch(new PageAddCID(queryParams.cID));

        const properties = {
          device: queryParams.cID,
          session: queryParams.sID,
        };

        if (queryParams.sID !== 'LOGOUT') {
          this.appInsightsService.logPageView('StartSite', null, properties);
        }

        this._store.dispatch(new GetIdentify());

        if (this._subscriptionIdentifyObs) {
          this._subscriptionIdentifyObs.unsubscribe();
        }
        this._subscriptionIdentifyObs = this._identifyObs$.subscribe((data) => {
          if (data && data.language && (!queryParams.language || queryParams.language === '')) {
            this.translateService.use(data.language);
            if (data.language === 'it-IT') {
              this._store.dispatch(new PageCoverVideo('assets/img/screen-video-horse-it.png'));
            }
          }
          if (queryParams.language && queryParams.language !== '') {
            this.translateService.use(queryParams.language);
          }
          if (data && this.router.url.search('/pages/') === 0) {
            this._store.dispatch(new GetMenu(null));
            this._store.dispatch(new GetNext());
            this._store.dispatch(new GetResultRace());
            this._store.dispatch(new GetChannels());
          }
        });

        // BRANDCOLOR E MOBILE HEIGHT PER MICROGAME
        if (microgameDark.includes(queryParams.cID) || microgameLight.includes(queryParams.cID)) {
          if (((!queryParams['cCSS'] || queryParams['cCSS'] !== '1') || !environment.staging)) {
            document.documentElement.style.setProperty('--brandColor', environment.cID[queryParams.cID].brandColor);
            document.documentElement.style.setProperty('--brandColorTxt', environment.cID[queryParams.cID].brandColorTxt);
          }
          if (environment.cID[queryParams.cID].mobileHeight !== undefined) {
            console.log(environment.cID[queryParams.cID].mobileHeight);
            this.postmessage.sendPostMessage({ mobileHeight: environment.cID[queryParams.cID].mobileHeight });
          } else {
            console.log(environment.cID[queryParams.cID].mobileHeight);
            this.postmessage.sendPostMessage({ mobileHeight: 70 });
          }
        }
      }
      if (queryParams.F_CB) {
        this._store.dispatch(new PageAddFunctionCompleteBet(queryParams.F_CB));
      }
      if (queryParams.F_OCB) {
        this._store.dispatch(new PageAddFunctionButtonBet(queryParams.F_OCB));
      }
      if (queryParams.gTRC) {
        this._store.dispatch(new PageAddTrackGA(queryParams.gTRC));
        this.googleAnalyticsService.initGoogleTag();
      }
      if (queryParams.sTL) {
        this._store.dispatch(new PageAddShowTicketList(JSON.parse(queryParams.sTL)));
      }
      if (queryParams.rMM && queryParams.rMM.length > 0) {
        this._store.dispatch(new PageShowMenu( false ));
      }
    });


  }

  /**
   * Dopo aver caricato il dom
   * mando ogni secondo l'atezza della pagnina all'iframe padre
   */
  ngAfterViewInit(): void {
    this._subscriptionTimerHeight = this._timerHeight.subscribe((val) => {
      const menu = document.getElementsByClassName('div-menu')[0]
        ? document.getElementsByClassName('div-menu')[0].scrollHeight + 60
        : 0;

      const legenda = document.getElementsByClassName('div-legenda')[0]
        ? document.getElementsByClassName('div-legenda')[0].scrollHeight
        : 0;

      const leftbar = menu + legenda;

      const cart = document.getElementsByClassName('mst-cart')[0]
        ? document.getElementsByClassName('mst-cart')[0].scrollHeight + 84
        : 0;

      const channel = document.getElementsByClassName('mst-channel')[0]
        ? document.getElementsByClassName('mst-channel')[0].scrollHeight
        : 0;

      const reminderbet = document.getElementById('div-reminders')
          ? document.getElementById('div-reminders').scrollHeight + 40
          : 0;

      const rightbar = cart + channel + reminderbet + 30;

      const content = document.getElementsByClassName('div-main')[0]
        ? document.getElementsByClassName('div-main')[0].scrollHeight
        : 0;

      const elemdialog = document.getElementsByClassName('panel-class')[0]
        ? <HTMLElement>document.getElementsByClassName('panel-class')[0]
        : null;

      const dialog = elemdialog
        ? Number(elemdialog.style.marginTop.replace('px', '')) + elemdialog.scrollHeight
        : 0;

      const tickets = document.getElementsByClassName('tickets-content')[0]
        ? document.getElementsByClassName('tickets-content')[0].scrollHeight + 4
        : 0;

      const ticketdetails = document.getElementById('frame-height')
        ? tickets + document.getElementById('frame-height').scrollHeight
        : 0;

      const minHeight = 400;

      const maxHeigh = Math.max(leftbar, content, dialog, tickets, rightbar, ticketdetails, minHeight);
      if (this._heightFrame !== maxHeigh) {
        this._heightFrame = maxHeigh;
        this.postmessage.sendPostMessage({ height: this._heightFrame });
        // window.parent.postMessage({ height: this._heightFrame }, '*');
      }
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showMessage = true;
        this.postmessage.sendPostMessage({ func: 'getIsReady' });
        // window.parent.postMessage(
        //     {
        //       func: 'getIsReady'
        //     },
        //     '*'
        // );
      }
    });

    if (isPlatformBrowser(this.platformId)) {
      const loader = this.renderer.selectRootElement('#loader');
      if (loader.style.display !== 'none') {
        loader.style.display = 'none'; // hide loader
      }
    }
  }

  ngOnDestroy(): void {
    // this.googleAnalyticsService.unsubscribe();
    this._subscriptionTimerHeight.unsubscribe();
    this._subscriptionIdentifyObs.unsubscribe();
    this._subscriptionmenuObs.unsubscribe();
  }
}
